'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dom = {
  headerCountdownTimer: '[data-header-countdown-timer]',
  dayCount: '[data-header-countdown-timer-day-count]',
  hourCount: '[data-header-countdown-timer-hour-count]',
  minuteCount: '[data-header-countdown-timer-minute-count]',
  secondCount: '[data-header-countdown-timer-second-count]'
};

var headerCountdownInterval = void 0;

var addLeadingZero = function addLeadingZero(count) {
  if (count < 10) {
    return '0' + count;
  }

  return count;
};

var updateTimer = function updateTimer(countdownDate, $dayCount, $hourCount, $minuteCount, $secondCount) {
  var secondsOnCountdown = Math.floor((countdownDate - Date.now()) / 1000);
  secondsOnCountdown = secondsOnCountdown < 0 ? 0 : secondsOnCountdown;

  var daysOnTimer = addLeadingZero(Math.floor(secondsOnCountdown / 86400));
  var hoursOnTimer = addLeadingZero(Math.floor(secondsOnCountdown % 86400 / 3600));
  var minutesOnTimer = addLeadingZero(Math.floor(secondsOnCountdown % 3600 / 60));
  var secondsOnTimer = addLeadingZero(secondsOnCountdown % 60);

  if (secondsOnCountdown === 0) {
    clearInterval(headerCountdownInterval);
  }

  $dayCount.html(daysOnTimer);
  $hourCount.html(hoursOnTimer);
  $minuteCount.html(minutesOnTimer);
  $secondCount.html(secondsOnTimer);
};

var parseDate = function parseDate(dateString) {
  var dateAndTime = dateString.split(' ');
  var date = dateAndTime[0].split('-');
  var time = dateAndTime[1].split(':');
  var year = date[0];
  var month = date[1] - 1;
  var day = date[2];
  var hour = time[0];
  var minutes = time[1];

  return new Date(year, month, day, hour, minutes);
};

var setup = function setup() {
  var $headerCountdownTimer = $(dom.headerCountdownTimer);
  if ($headerCountdownTimer.length < 1) {
    return;
  }

  var nowLocalTime = new Date();
  var nowMountainTime = new Date(new Date().toLocaleString('en-US', { timeZone: "America/Denver" }));
  var offset = nowLocalTime - nowMountainTime;
  var countdownDate = parseDate($headerCountdownTimer.data('headerCountdownTimer'));
  var countdownDateInMountainTime = new Date(Date.parse(countdownDate) + offset);

  var $dayCount = $(dom.dayCount, $headerCountdownTimer);
  var $hourCount = $(dom.hourCount, $headerCountdownTimer);
  var $minuteCount = $(dom.minuteCount, $headerCountdownTimer);
  var $secondCount = $(dom.secondCount, $headerCountdownTimer);

  if (countdownDateInMountainTime < nowLocalTime) {
    return;
  }

  $headerCountdownTimer.closest('.header-countdown').addClass('header-countdown--show-timer');
  updateTimer(countdownDateInMountainTime, $dayCount, $hourCount, $minuteCount, $secondCount);
  headerCountdownInterval = window.setInterval(updateTimer, 1000, countdownDateInMountainTime, $dayCount, $hourCount, $minuteCount, $secondCount);
};

exports.default = {
  setup: setup
};